<template>
  <v-layout row wrap>
    <v-flex xs12 md12>
      <TwoFactorAuthenticationForm ref="form" @on-submit="onFormSubmit" @on-close="$emit('on-close')" />
    </v-flex>
  </v-layout>
</template>

<script>
import TwoFactorAuthenticationForm from './components/TwoFactorAuthenticationForm'

export default {
  name: 'TwoFactorAuthenticationSetup',
  components: {
    TwoFactorAuthenticationForm
  },
  data() {
    return {
      loadingSubmit: false,
    }
  },
  methods: {
    onOpen() {
      this.$refs.form.onOpen()
    },
    l(str) {
      return this.$root.l(str)
    },
    onFormSubmit(code) {
       if(this.loadingSubmit) {
        return
      }
      this.loadingSubmit = true

      let successCallback = (response) => {
        this.loadingSubmit = false
        if(response.body.error) {
          this.$refs.form.raiseError(this.l("O código enviado não esta correto, tente novamente."))
          return
        }
        let expire_at = new Date((new Date).getTime() + 60*12*60000) // 12 hours
        this.$cookies.set('2fa_authenticated', true, expire_at)
        this.dialog = false
        this.$router.push('/dashboard')
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
        this.loadingSubmit = false
      }

      const payload = {
        code
      }

      let token = this.$cookies.get('api_token')
      this.$http.post(
        this.$root.urls.twofactorauthentication_code,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      ).then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>



// WEBPACK FOOTER //
// src/TwoFactorAuthenticationLogin.vue